import axios from 'axios';

const API_BASE = '/api/shop-tasks';

export const shopTaskService = {
  getAll: async (params = {}) => {
    const response = await axios.get(API_BASE, { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await axios.get(`${API_BASE}/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await axios.post(API_BASE, data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await axios.put(`${API_BASE}/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await axios.delete(`${API_BASE}/${id}`);
    return response.data;
  },

  getOrderOptions: async (includeId) => {
    const response = await axios.get(`${API_BASE}/order-options`, {
      params: includeId ? { include_id: includeId } : {},
    });
    return response.data;
  },

  getAllocations: async ({ date, employeeId } = {}) => {
    const response = await axios.get(`${API_BASE}/allocations`, {
      params: { date, employee_id: employeeId || undefined },
    });
    return response.data;
  },

  saveAllocations: async (timeEntryId, rows, auditNotes) => {
    const response = await axios.put(`${API_BASE}/allocations/${timeEntryId}`, {
      rows,
      audit_notes: auditNotes || undefined,
    });
    return response.data;
  },
};
